/**
 * Google Analytics utility functions using native gtag.js
 * Note: Google Analytics is initialized in index.html via a script tag
 */

// Store the measurement ID when available
let measurementId = null;

/**
 * Set the measurement ID (called from index.html after initialization)
 */
export const setMeasurementId = (id) => {
  measurementId = id;
};

/**
 * Get the measurement ID from window or dataLayer
 */
const getMeasurementId = () => {
  if (measurementId) return measurementId;
  
  // Try to get from window (set by index.html)
  if (typeof window !== "undefined" && window.GA_MEASUREMENT_ID) {
    measurementId = window.GA_MEASUREMENT_ID;
    return measurementId;
  }
  
  // Try to get from dataLayer config events
  if (typeof window !== "undefined" && window.dataLayer) {
    for (let i = window.dataLayer.length - 1; i >= 0; i--) {
      if (window.dataLayer[i] && window.dataLayer[i][0] === "config") {
        measurementId = window.dataLayer[i][1];
        return measurementId;
      }
    }
  }
  return null;
};

/**
 * Check if Google Analytics is initialized (gtag is available)
 */
const isGAInitialized = () => {
  return typeof window !== "undefined" && 
         typeof window.gtag === "function" && 
         window.dataLayer;
};

/**
 * Track page view for Google Analytics using native gtag
 */
export const trackPageView = (path, title = null) => {
  if (isGAInitialized()) {
    try {
      const id = getMeasurementId();
      if (id) {
        const config = {
          page_path: path,
        };
        if (title) {
          config.page_title = title;
        }
        window.gtag("config", id, config);
      } else {
        // Fallback: use event-based page view
        window.gtag("event", "page_view", {
          page_path: path,
          page_title: title || document.title,
        });
    }
  } catch (error) {
      console.error("❌ Error tracking page view:", error);
    }
  }
};

/**
 * Track custom event using native gtag
 */
export const trackEvent = (eventName, eventParams = {}) => {
  if (isGAInitialized()) {
    try {
      window.gtag("event", eventName, eventParams);
    } catch (error) {
      console.error("❌ Error tracking event:", error);
    }
  }
};

/**
 * Check if Google Analytics is initialized (exported for external use)
 */
export const isGAReady = () => {
  return isGAInitialized();
};
